import { extensionsConfig } from "client/config/extensionsConfig";
import { useGoogleDriveUpload } from "client/hooks/upload/useGoogleDriveUpload";
import { useToggle } from "client/hooks/utils/useToggle";
import { AddIcon } from "components/common/Icons/AddIcon";
import { List } from "components/common/List/List";
import { Popup } from "components/common/Popup/Popup";
import { DeviceUpload } from "components/common/Upload/DeviceUpload/DeviceUpload";
import { DropboxUpload } from "components/common/Upload/DropboxUpload/DropboxUpload";
import { GoogleDriveAccessErrorModal } from "components/common/Upload/GoogleDriveUpload/GoogleDriveAccessErrorModal/GoogleDriveAccessErrorModal";
import { GoogleDriveUpload } from "components/common/Upload/GoogleDriveUpload/GoogleDriveUpload";
import { UrlUpload } from "components/common/Upload/UrlUpload/UrlUpload";
import { useUploadImage } from "../../EditSettings/UploadImage/useUploadImage";

const supportedExtensions = extensionsConfig.flip;

export const AddImage = () => {
    const { isOpen, onClose: close, open } = useToggle();
    const { handleFile, handleUploadStart, handleClick } = useUploadImage();
    const {
        handleClick: handleGoogleDriveUploadClick,
        accessError,
        setAccessError,
        isLoading: isGoogleDriveLoading,
    } = useGoogleDriveUpload(handleFile, { allowMultiple: false, supportedExtensions }, isOpen);

    return (
        <>
            <GoogleDriveAccessErrorModal
                isOpen={accessError}
                close={() => setAccessError(false)}
                handleRetry={handleGoogleDriveUploadClick}
            />
            <Popup
                isOpen={isOpen}
                close={close}
                content={
                    <div className="absolute bg-white dark:bg-darkSurface-200 left-0 bottom-full border dark:border-darkSurface-400 shadow-xl rounded-xl my-2 flex flex-col gap-2 text-black dark:text-white">
                        <List
                            callback={() => {}}
                            items={{
                                from_device: (
                                    <DeviceUpload
                                        handleFile={handleFile}
                                        htmlFileInputId="flip-rotate-file-input"
                                        options={{
                                            allowMultiple: false,
                                            onClick: handleClick,
                                            supportedExtensions,
                                        }}
                                    />
                                ),
                                dropbox: (
                                    <DropboxUpload
                                        handleFile={handleFile}
                                        options={{
                                            allowMultiple: false,
                                            uploadStart: handleUploadStart,
                                            onClick: () => {
                                                handleClick();
                                            },
                                            supportedExtensions,
                                        }}
                                        isOpen={isOpen}
                                    />
                                ),
                                google_drive: (
                                    <GoogleDriveUpload
                                        options={{
                                            allowMultiple: false,
                                            uploadStart: handleUploadStart,
                                            onClick: () => {
                                                handleGoogleDriveUploadClick();
                                                handleClick();
                                            },
                                            supportedExtensions,
                                        }}
                                        isLoading={isGoogleDriveLoading}
                                    />
                                ),
                                url_upload: (
                                    <UrlUpload
                                        handleFile={handleFile}
                                        options={{
                                            uploadStart: handleUploadStart,
                                            onClick: handleClick,
                                            supportedExtensions,
                                        }}
                                    />
                                ),
                            }}
                        />
                    </div>
                }
            >
                <div className="px-4 py-4 border-r border-irBlue-400" onClick={open}>
                    <AddIcon className="fill-white" />
                </div>
            </Popup>
        </>
    );
};
